import moment from 'moment';
import { object, string, number, array } from 'yup';

import { Event } from '../../../../types';

let generalSchema = object({
  type: string().required('Project type is required'),
  name: string().required('Project name is required'),
});

let brandSchema = object({
  type: string().required('Project type is required'),
  name: string().required('Project name is required'),
  startDate: string().test({
    name: 'test-start-date',
    test(value, ctx) {
      let now = moment().utc();

      if (!value) return ctx.createError({ message: 'Start date is required' });
      if (moment(value).isBefore(now, 'day'))
        return ctx.createError({
          message: 'Start date cannot be earlier than current date',
        });
      return true;
    },
  }),
  endDate: string().test({
    name: 'test-end-date',
    test(value, ctx) {
      if (!value) return ctx.createError({ message: 'End date is required' });
      if (moment(value).isBefore(ctx.parent.startDate, 'day'))
        return ctx.createError({
          message: 'End date cannot be earlier than start date',
        });
      return true;
    },
  }),
  videoMode: string().required('Orientation is required'),
  wildcards: array(number()).test({
    name: 'test-wildcards',
    test(value, ctx) {
      if (!value?.every((v: any) => parseFloat(v) > 0))
        return ctx.createError({
          message: "Some wildcards' duration is invalid",
        });
      return true;
    },
  }),
});

const getSchema = (validationType: string) => {
  switch (validationType) {
    case 'general-videographer':
      return generalSchema;
    case 'general-brand':
      return brandSchema;
    default:
      return null;
  }
};

export const validateForm = async (
  validationType: string,
  formData: Partial<Event>,
) => {
  const errors: Record<string, string> = {};

  const schema = getSchema(validationType);

  if (!!schema)
    await schema.validate(formData, { abortEarly: false }).catch((err) => {
      err.inner.forEach((error: any) => {
        errors[error.path] = error.errors[0];
      });
    });

  return errors;
};
